<template>
    <div
        class="z-accordion"
        :class="{'z-accordion--nested': nested}"
    >
        <slot />
    </div>
</template>

<script setup>
import { provide, defineProps, ref, inject, onMounted, useSlots } from 'vue'
const slots = useSlots()

const props = defineProps({
    nested: {
        type: Boolean,
        default: false
    },
    multiple: {
        type: Boolean,
        default: false
    },
    initial: {
        type: String,
        default: 'closed',
        validator: (prop) => ['first', 'closed'].includes(prop)
    }
})
const nestedHandler = ref(null)
const foldersHandler = ref(null)
const isMultiple = ref(props.multiple)
const openedItem = ref(new Set())
const firstAccordionItemId = ref(null)

// Nested
if (props.nested) {
    nestedHandler.value = inject('nested')
    isMultiple.value = inject('is-multiple')
    foldersHandler.value = inject('folders')
}
// end Nested

const changeOpenedItem = (id) => {
    if (openedItem.value.has(id)) {
        openedItem.value.delete(id)
        return
    }

    if (isMultiple.value) {
        openedItem.value.add(id)
        return
    }

    if (props.nested && nestedHandler.value !== null) {
        nestedHandler.value()
    }

    openedItem.value.clear()
    openedItem.value.add(id)
}

const openFirstItem = () => {
    const defaultSlots = slots.default()
    const firstDefaultSlot = defaultSlots[0]
    const accordionItemCb = (el) => el.type.__name === 'ZAccordionItem'

    let firstAccordionItem = null
    if (typeof firstDefaultSlot.type === 'symbol') {
        firstAccordionItem = firstDefaultSlot.children.find(accordionItemCb)
    } else {
        firstAccordionItem = defaultSlots.find(accordionItemCb)
    }

    firstAccordionItemId.value = firstAccordionItem.props?.id

    if (firstAccordionItemId.value) {
        changeOpenedItem(firstAccordionItemId.value)
        window.location.hash = `accordion-${firstAccordionItemId.value}`
    }
}

provide('accordion-item', {
    openedItem,
    changeOpenedItem
})

provide('is-multiple', isMultiple.value)

onMounted(() => {
    if (props.initial === 'first' && !window.location.hash) {
        openFirstItem()
    }

    if (props.nested && foldersHandler.value !== null) {
        foldersHandler.value()
    }
})
</script>

<style lang="scss" src="./index.scss"></style>
